export const VARIABLES = {
	COLORS: {
		GRAY: {
			0:   'hsl(var(--gray-0))',
			50:  'hsl(var(--gray-50))',
			100: 'hsl(var(--gray-100))',
			200: 'hsl(var(--gray-200))',
			300: 'hsl(var(--gray-300))',
			400: 'hsl(var(--gray-400))',
			500: 'hsl(var(--gray-500))',
			600: 'hsl(var(--gray-600))',
			700: 'hsl(var(--gray-700))',
			800: 'hsl(var(--gray-800))',
			900: 'hsl(var(--gray-900))',
			950: 'hsl(var(--gray-950))',
		},
		ORANGE: {
			50:  'hsl(var(--orange-50))',
			100: 'hsl(var(--orange-100))',
			200: 'hsl(var(--orange-200))',
			300: 'hsl(var(--orange-300))',
			400: 'hsl(var(--orange-400))',
			500: 'hsl(var(--orange-500))',
			600: 'hsl(var(--orange-600))',
			700: 'hsl(var(--orange-700))',
			800: 'hsl(var(--orange-800))',
			900: 'hsl(var(--orange-900))',
			950: 'hsl(var(--orange-950))',
		},
		VIOLET: {
			50:  'hsl(var(--violet-50))',
			100: 'hsl(var(--violet-100))',
			200: 'hsl(var(--violet-200))',
			300: 'hsl(var(--violet-300))',
			400: 'hsl(var(--violet-400))',
			500: 'hsl(var(--violet-500))',
			600: 'hsl(var(--violet-600))',
			700: 'hsl(var(--violet-700))',
			800: 'hsl(var(--violet-800))',
			900: 'hsl(var(--violet-900))',
			950: 'hsl(var(--violet-950))',
		},
		CYAN: {
			50:  'hsl(var(--cyan-50))',
			100: 'hsl(var(--cyan-100))',
			200: 'hsl(var(--cyan-200))',
			300: 'hsl(var(--cyan-300))',
			400: 'hsl(var(--cyan-400))',
			500: 'hsl(var(--cyan-500))',
			600: 'hsl(var(--cyan-600))',
			700: 'hsl(var(--cyan-700))',
			800: 'hsl(var(--cyan-800))',
			900: 'hsl(var(--cyan-900))',
			950: 'hsl(var(--cyan-950))',
		},
		TURQUOISE: {
			50:  'hsl(var(--turquoise-50))',
			100: 'hsl(var(--turquoise-100))',
			200: 'hsl(var(--turquoise-200))',
			300: 'hsl(var(--turquoise-300))',
			400: 'hsl(var(--turquoise-400))',
			500: 'hsl(var(--turquoise-500))',
			600: 'hsl(var(--turquoise-600))',
			700: 'hsl(var(--turquoise-700))',
			800: 'hsl(var(--turquoise-800))',
			900: 'hsl(var(--turquoise-900))',
			950: 'hsl(var(--turquoise-950))',
		},
		YELLOW: {
			50:  'hsl(var(--yellow-50))',
			100: 'hsl(var(--yellow-100))',
			200: 'hsl(var(--yellow-200))',
			300: 'hsl(var(--yellow-300))',
			400: 'hsl(var(--yellow-400))',
			500: 'hsl(var(--yellow-500))',
			600: 'hsl(var(--yellow-600))',
			700: 'hsl(var(--yellow-700))',
			800: 'hsl(var(--yellow-800))',
			900: 'hsl(var(--yellow-900))',
			950: 'hsl(var(--yellow-950))',
		},
		APPLE_GREEN: {
			50:  'hsl(var(--apple-green-50))',
			100: 'hsl(var(--apple-green-100))',
			200: 'hsl(var(--apple-green-200))',
			300: 'hsl(var(--apple-green-300))',
			400: 'hsl(var(--apple-green-400))',
			500: 'hsl(var(--apple-green-500))',
			600: 'hsl(var(--apple-green-600))',
			700: 'hsl(var(--apple-green-700))',
			800: 'hsl(var(--apple-green-800))',
			900: 'hsl(var(--apple-green-900))',
			950: 'hsl(var(--apple-green-950))',
		},
		GREEN: {
			50:  'hsl(var(--green-50))',
			100: 'hsl(var(--green-100))',
			200: 'hsl(var(--green-200))',
			300: 'hsl(var(--green-300))',
			400: 'hsl(var(--green-400))',
			500: 'hsl(var(--green-500))',
			600: 'hsl(var(--green-600))',
			700: 'hsl(var(--green-700))',
			800: 'hsl(var(--green-800))',
			900: 'hsl(var(--green-900))',
			950: 'hsl(var(--green-950))',
		},
		RED: {
			50:  'hsl(var(--red-50))',
			100: 'hsl(var(--red-100))',
			200: 'hsl(var(--red-200))',
			300: 'hsl(var(--red-300))',
			400: 'hsl(var(--red-400))',
			500: 'hsl(var(--red-500))',
			600: 'hsl(var(--red-600))',
			700: 'hsl(var(--red-700))',
			800: 'hsl(var(--red-800))',
			900: 'hsl(var(--red-900))',
			950: 'hsl(var(--red-950))',
		},
		ROSE: {
			50:  'hsl(var(--rose-50))',
			100: 'hsl(var(--rose-100))',
			200: 'hsl(var(--rose-200))',
			300: 'hsl(var(--rose-300))',
			400: 'hsl(var(--rose-400))',
			500: 'hsl(var(--rose-500))',
			600: 'hsl(var(--rose-600))',
			700: 'hsl(var(--rose-700))',
			800: 'hsl(var(--rose-800))',
			900: 'hsl(var(--rose-900))',
			950: 'hsl(var(--rose-950))',
		},
		PURPLE: {
			50:  'hsl(var(--purple-50))',
			100: 'hsl(var(--purple-100))',
			200: 'hsl(var(--purple-200))',
			300: 'hsl(var(--purple-300))',
			400: 'hsl(var(--purple-400))',
			500: 'hsl(var(--purple-500))',
			600: 'hsl(var(--purple-600))',
			700: 'hsl(var(--purple-700))',
			800: 'hsl(var(--purple-800))',
			900: 'hsl(var(--purple-900))',
			950: 'hsl(var(--purple-950))',
		},
		PARTNER: {
			50:  'hsl(var(--partner-50))',
			100: 'hsl(var(--partner-100))',
			200: 'hsl(var(--partner-200))',
			300: 'hsl(var(--partner-300))',
			400: 'hsl(var(--partner-400))',
			500: 'hsl(var(--partner-500))',
			600: 'hsl(var(--partner-600))',
			700: 'hsl(var(--partner-700))',
			800: 'hsl(var(--partner-800))',
			900: 'hsl(var(--partner-900))',
			950: 'hsl(var(--partner-950))',
		},
		BLUE: {
			50:  'hsl(var(--blue-50))',
			100: 'hsl(var(--blue-100))',
			200: 'hsl(var(--blue-200))',
			300: 'hsl(var(--blue-300))',
			400: 'hsl(var(--blue-400))',
			500: 'hsl(var(--blue-500))',
			600: 'hsl(var(--blue-600))',
			700: 'hsl(var(--blue-700))',
			800: 'hsl(var(--blue-800))',
			900: 'hsl(var(--blue-900))',
			950: 'hsl(var(--blue-950))',
		},
	},
} as const;
